/* eslint-disable */

export default {
  'Get </amount>': 'Get ${{</amount>}}',
  'Enter a promo code! First limit people receive amount coins':
    'Enter a promo code! First {{</limit>}} people receive {{</amount>}} coins',
};
